import { Vertical } from 'component/Vertical'
import { observer } from 'mobx-react-lite'
import { MobileFilters } from 'page/catalog/DemoCatalogFilters/MobileFilters'
import { StandGenders } from 'page/catalog/StandGenders/StandGenders'
import { useDemo } from 'page/catalog/store/CatalogContext'

export const StandFilters = observer(() => {
  const demo = useDemo()
  const { options } = demo
  const { ready, genders } = options
  const { search } = demo.product

  if (!ready && !search) return null

  return (
    <Vertical gap={16}>
      {genders && <StandGenders />}
      <MobileFilters />
    </Vertical>
  )
})
